var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkGreenLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7791 1.66663C12.341 1.66663 11.9854 2.02218 11.9854 2.46028C11.9854 2.89837 12.341 3.25393 12.7791 3.25393H15.6251L9.04334 9.83565C8.73342 10.1456 8.73342 10.648 9.04334 10.9579C9.1985 11.1131 9.4013 11.1904 9.60448 11.1904C9.80765 11.1904 10.0105 11.1131 10.1656 10.9579L16.7473 4.3762V7.22218C16.7473 7.66028 17.1029 8.01583 17.541 8.01583C17.9791 8.01583 18.3346 7.66028 18.3346 7.22218V2.46028C18.3346 2.02218 17.9791 1.66663 17.541 1.66663H12.7791ZM4.04892 2.46028C2.73583 2.46028 1.66797 3.52813 1.66797 4.84123V15.9523C1.66797 17.2654 2.73583 18.3333 4.04892 18.3333H15.16C16.4731 18.3333 17.541 17.2654 17.541 15.9523V11.1904C17.541 10.7523 17.1854 10.3968 16.7473 10.3968C16.3092 10.3968 15.9537 10.7523 15.9537 11.1904V15.9523C15.9537 16.39 15.5977 16.746 15.16 16.746H4.04892C3.61122 16.746 3.25527 16.39 3.25527 15.9523V4.84123C3.25527 4.40353 3.61122 4.04758 4.04892 4.04758H8.81083C9.24892 4.04758 9.60448 3.69202 9.60448 3.25393C9.60448 2.81583 9.24892 2.46028 8.81083 2.46028H4.04892Z",
    fill: "#02B37F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGreenLight);
export default __webpack_public_path__ + "static/media/link-greenLight.7dd07b73d670eaa5bd8183810aac542e.svg";
export { ForwardRef as ReactComponent };